import CryptoJS from 'crypto-js'
export default {
    // 加密
    encrypt(word) {
        var keyStr = 'hxxxkjcttx987521';
        var key = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString().split('%').join('%25').split('+').join('%2B').split(' ').join('%20').split('/').join('%2F')
            .split('?').join('%3F').split('#').join('%23').split('&amp;').join('%26')
            .split('=').join('%3D');
    },
    // 解密
    decrypt(word) {
        var keyStr = 'hxxxkjcttx987521';
        var key = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
}
